export default "__VITE_ASSET__D8g8W271__"